import React__default from 'react';
import ErrorScreen from './components/ErrorScreen/ErrorScreen.js';

function DmErrorScreen(props) {
  var className = props.className,
    style = props.style,
    error = props.error,
    titleText = props.titleText,
    descriptionText = props.descriptionText,
    actionText = props.actionText,
    actionIcon = props.actionIcon,
    onClick = props.onClick;
  return /*#__PURE__*/React__default.createElement(ErrorScreen, {
    className: className,
    style: style,
    error: error,
    titleText: titleText,
    descriptionText: descriptionText,
    actionText: actionText,
    actionIcon: actionIcon,
    onClick: onClick
  });
}
DmErrorScreen.defaultProps = {
  error: '404',
  onClick: function onClick() {},
  className: undefined,
  style: undefined
};

export { DmErrorScreen };
